import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const GEOIP_CITY_SCHEMA = Object.freeze({
  NAME: '',
});
const RECORD = generateSchema(GEOIP_CITY_SCHEMA);
const KEYS: any = generateKeys(GEOIP_CITY_SCHEMA);

export class GeoipCity extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }
}
